/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const componentsModals: { [k: string]: LazyModal } = {
  CustomBannerPopUpModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.component'
      ).then(m => m.CustomBannerPopUpModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.module'
      ).then(m => m.CustomBannerPopUpModalModule),
  },
  FileViewerModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/file-viewer/file-viewer-modal/file-viewer-modal.component'
      ).then(m => m.FileViewerModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/file-viewer/file-viewer-modal/file-viewer-modal.module'
      ).then(m => m.FileViewerModalModule),
  },
  UserFeedbackModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.component'
      ).then(m => m.UserFeedbackModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.module'
      ).then(m => m.UserFeedbackModalModule),
  },
};
